<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-money-bill-transfer"></i></span>{{ 'TariffRate.Header' | translate }}</h1>
  <p-card>
      <form class="detail-form">
        <div class="field grid">
          <div class="p-fluid field grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.Form.Forwarder' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.forwarder | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.Form.SKU' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.sku | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.TariffRate' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.tariffRate | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.CustomsNumber' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.customsTariff | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.SKUDescription' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.skuDescription | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.FilingDate' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.declarationDt | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>

            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.Brand' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.brand | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.IsValid' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.isActivated | optionsMapping:isActivatedOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.StartDate' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.startDt | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.EndDate' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.endDt | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.Creator' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.createUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.CreationTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.UpdateBy' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.updateUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRate.MainTable.UpdateTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ tariffRate?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button *ngIf="isShowEditBtn" pButton pRipple label="{{ 'Common.Button.Edit' | translate }}" (click)="goToEdit($event)" class="mr-2"></button>
              <button *ngIf="isShowCancelBtn" pButton pRipple label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}" (click)="goToSearchPage()" class="p-button-secondary"></button>
            </div>
          </div>
        </div>
      </form>
  </p-card>
</div>
